<template>
  <!-- シートのis_expiredフラグが立っている&カウントダウンが0ならグレーアウト -->
  <div
    class="list-item__ticket"
    :class="{
      used:
        (sheet.is_expired && countDown == '00:00:00:00') ||
        isUsedCoupon ||
        !isExchangeable,
    }"
  >
    <!-- シート名 -->
    <div class="index-ticket-left">
      <span class="list-item__title passsheet_title">
        {{ displaySheetName(bookGroup, sheet) }}
      </span>
    </div>

    <!-- 右部ステイタス表示 -->
    <SUseStatusButton
      v-if="showSUseStatusButton"
      :book-group="bookGroup"
      :sheet="sheet"
      :my-coupon="myCoupon"
      :is-available-period="isAvailablePeriod"
      :is-used-coupon="isUsedCoupon"
      :count-down="countDown"
    />
    <!-- 右部ステイタス表示 -->

    <div class="ticket-index-square left-square"></div>
    <div class="ticket-index-square right-square"></div>
  </div>
</template>
<script>
import { onMounted, computed, ref } from "vue";

import commonService from "@/services/common";
import myTicketsCommonService from "@/services/common/myTickets";

export default {
  name: "ItemIndexSheetTile",
  props: {
    bookGroup: {
      type: Object,
      required: true,
    },
    sheet: {
      type: Object,
      required: true,
    },
    myCoupon: {
      type: Object,
      default: null,
    },
    isAvailablePeriod: {
      type: Boolean,
      required: true,
    },
    isExpiredBook: {
      type: Boolean,
      required: true,
    },
    isUsedStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const countDown = ref(null);

    const showSUseStatusButton = computed(() => {
      if (!props.isUsedStatus && props.sheet.is_expired) {
        return true;
      }
      return !(props.isExpiredBook && countDown.value === "00:00:00:00");
    });

    const isUsedCoupon = computed(() =>
      props.myCoupon
        ? props.myCoupon.used_count >= props.myCoupon.use_limit
        : false
    );

    const isExchangeable = computed(() =>
      props.myCoupon
        ? props.myCoupon.is_exchangeable &&
          // 渋沢-足柄のように特急の発駅がないクーポンの場合は無効とする
          props.myCoupon.allowed_from_stations.length > 0 &&
          props.myCoupon.allowed_to_stations.length > 0
        : true
    );

    onMounted(() => {
      if (!props.myCoupon) {
        updateCountDown();
        setInterval(() => updateCountDown(), 1 * 1000);
      }
    });

    const updateCountDown = () => {
      // 最新のstamped_at取得
      let latestStampedAt = null;
      if (
        commonService.sortByDateTimeLaterFirst(props.sheet.frames).length > 0
      ) {
        latestStampedAt = commonService.sortByDateTimeLaterFirst(
          props.sheet.frames
        )[0].stamped_at;
      }
      // 最新のstamped_atが有効であれば使用済みの扱いでcoutDownを計算する
      if (latestStampedAt !== null) {
        const limit = myTicketsCommonService.getCountDownLimit(
          latestStampedAt,
          props.sheet._master_sheet.content.description_json.FaceCountDown
        );
        countDown.value = myTicketsCommonService.getCountDown(limit);
        // bookが失効済みでstamped_atがない場合、未使用で期限切れなのでcountDown:0として扱う
      } else if (props.isExpiredBook && latestStampedAt === null) {
        countDown.value = "00:00:00:00";
      }
    };

    return {
      countDown,
      showSUseStatusButton,
      isUsedCoupon,
      isExchangeable,
    };
  },
};
</script>
<style lang="scss" scoped>
.used {
  background: #f0f0f0;
}

.list-item__ticket {
  height: 51px;
  position: relative;
  border-top: 1px dashed #d7d7d7;
}

.list-item__ticket .used {
  height: 12vw;
  border-top: 1px dashed #f9f9f9;
}

.list-item__title {
  font-size: 15px;
  position: absolute;
  top: 25%;
  overflow: hidden;
  font-weight: bold;
}

.index-ticket-left {
  float: left;
  width: 77%;
  font-size: 3vw;
  overflow: hidden;
  padding: 0 2%;
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.passsheet_title {
  position: unset;
  display: block;
  margin: 4vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
}

.ticket-index-square {
  position: relative;
  width: 16px;
  height: 16px;
  background-color: #f9f9f9;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 0;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}

.left-square {
  margin-left: -5.5px;
  top: -10px;
  border-bottom: none;
  border-left: none;
}

.right-square {
  margin-left: calc(100% - 12px);
  top: -26px;
  border-top: none;
  border-right: none;
}

@media screen and (min-width: 421px) {
  .list-item__ticket {
    height: 12vw;
  }

  .list-item__title {
    font-size: 4vw;
  }
}
</style>
